import React, {useState, useContext} from 'react';
import glamorous from 'glamorous';
import {withAnalyticsPayload} from '../../../shared/enhancers/analytics-enhancer';
import {compose} from 'react-apollo';
import SignUpHeader from '../components/sign-up-header';
import PrivateTeamFeatures from '../components/private-team-features';
import Pricing from '../components/pricing';
import {BASE_TEXT} from '../../../shared/style/typography';
import {useSendAnalyticsEvent} from '../../../shared/enhancers/analytics-enhancer';
import {CurrentUserContext} from '../../../shared/enhancers/current-user-enhancer';
import {redirectTo} from '../../../shared/utils/navigation';
import {githubMarketplace} from '../constants';
import Howitworks from '../components/how-it-works';
import CompaniesUsing from '../components/companies-using';
import Features from '../components/feature-card/features';
import GetStarted from '../components/get-started';
import FooterCta from '../components/footer-cta';
import StackShareEnterpriseForm from '../../../shared/library/stackshare-enterprise-form';

const Page = glamorous.div({
  ...BASE_TEXT,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: '100vh',
  position: 'relative'
});

const Enterprise = () => {
  const [signUpModal, setSignUpModal] = useState(false);
  const sendAnalyticsEvent = useSendAnalyticsEvent();
  const currentUser = useContext(CurrentUserContext);

  const showSignUpModal = (buttonClicked, sectionName) => {
    sendAnalyticsEvent('sign_up_private_stackshare', {
      index: buttonClicked,
      sectionName: sectionName
    });
    setSignUpModal(true);
  };

  const hideSignUpModal = () => setSignUpModal(false);

  const goToManageCompaniesPage = (buttonClicked, sectionName) => {
    sendAnalyticsEvent('sign_up_private_stackshare', {
      index: buttonClicked,
      sectionName: sectionName
    });
    redirectTo('/manage-companies/enterprise');
  };

  const goToGithubMarketPlace = (buttonClicked, sectionName) => {
    sendAnalyticsEvent('github_marketplace', {
      index: buttonClicked,
      sectionName: sectionName
    });
    window.location = githubMarketplace;
  };

  return (
    <Page>
      <SignUpHeader
        goToManageCompaniesPage={goToManageCompaniesPage}
        goToGithubMarketPlace={goToGithubMarketPlace}
      />
      <CompaniesUsing />
      <Features />
      <GetStarted />
      <Howitworks />
      <PrivateTeamFeatures
        goToManageCompaniesPage={goToManageCompaniesPage}
        goToGithubMarketPlace={goToGithubMarketPlace}
      />
      <Pricing
        showSignUpModal={showSignUpModal}
        currentUser={currentUser}
        goToManageCompaniesPage={goToManageCompaniesPage}
      />
      <FooterCta />
      {signUpModal && (
        <StackShareEnterpriseForm
          onDismiss={hideSignUpModal}
          title="Have questions before you sign up?"
          type="signup"
        />
      )}
    </Page>
  );
};

export default compose(
  withAnalyticsPayload({
    'page.name': 'Private Landing',
    path: typeof window !== 'undefined' ? window.location.pathname : null,
    url: typeof window !== 'undefined' ? window.location.href : null,
    referrer: typeof document !== 'undefined' ? document.referrer : null
  })
)(Enterprise);
